export const permPlacementDetailsRoutes = [
  {
    path: ':referenceNumber',
    name: 'perm-placement-details',
    component: () =>
      import(/* webpackChunkName: "perm-placement-details" */ './PermPlacementDetails.vue')
  }
];
